export default __webpack_public_path__ + "static/media/dv_2.8cd03956.svg";